import { Plan } from 'src/app/models/Plan';

export const addIdToPlans = (_plans: Plan[]): Plan[] =>
  _plans.map((plan, i) => ({
    ...plan,
    id: i + 1,
  }));
